var _rect, _circle, _line, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVol({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "warning-circle-thin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 19,
    height: 19,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(2 2)",
    fill: "none",
    stroke: "#ff9e17",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Ligne_15",
    "data-name": "Ligne 15",
    y2: 4,
    transform: "translate(10 6)",
    fill: "none",
    stroke: "#ff9e17",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 0.244,
    cy: 0.244,
    r: 0.244,
    transform: "translate(9.743 12.666)",
    fill: "none",
    stroke: "#ff9e17",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVol);
export default __webpack_public_path__ + "static/media/vol.ff8ad89f366e6e85f0ba84b3310b9afd.svg";
export { ForwardRef as ReactComponent };